import React from "react";
import { observer } from "mobx-react";
import { UserViewStore } from "../../store";
import { UserViewForm } from "./UserViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type UserViewProps = {
  userViewStore: UserViewStore;
};

export const UserView: React.FC<UserViewProps> = observer(
  ({ userViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <UserViewForm
          userViewStore={userViewStore}
          name={userViewStore.nameValue}
          email={userViewStore.emailValue}
          roleValue={userViewStore.roleValue}
          languageOptions={userViewStore.getLanguageOptions()}
          language={userViewStore.languageValue}
          avatarFiles={userViewStore.avatarFiles}
          tenantDisplayName={userViewStore.tenantDisplayNameValue}
          active={userViewStore.activeValue}
          cellphone={userViewStore.cellphoneValue}
          twoFaseAuth={userViewStore.twoFaseAuthValue}
          idCardTypeOptions={userViewStore.getIdCardTypeOptions()}
          idCardType={userViewStore.idCardTypeValue}
          idCard={userViewStore.idCardValue}
          genderOptions={userViewStore.getGenderOptions()}
          gender={userViewStore.genderValue}
          onPrint={(handlePrint: () => void) =>
            userViewStore.printUser(handlePrint)
          }
          onCancel={() => userViewStore.cancelUser()}
          onEdit={
            userViewStore.isEditEnabled
              ? () => userViewStore.editUser()
              : undefined
          }
          avatarViewAction={getViewAction(
            (props) => userViewStore.fileDownload(props, "avatar"),
            (props) => userViewStore.viewFilePdf(props, "avatar")
          )}
        />
        <ErrorDialog
          open={userViewStore.errorDialogOpened}
          title={userViewStore.errorTitle}
          description={userViewStore.errorDescription}
          onClose={() => userViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={userViewStore.pdfViewerOpen}
          onClose={() => userViewStore.closePdfViewer()}
          pdfUrl={userViewStore.pdfViewerUrl}
          title={userViewStore.pdfViewerTitle}
        />
      </div>
    );
  }
);
